import React from 'react'
import { useTranslation } from 'react-i18next';
import { careers1, careers2, careers3, careers4, careers5, rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
      {
        id: 1,
        imgSrc: subMenuHome,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '15.04.2025',
      },
      {
        id: 2,
        imgSrc: subMenuPartners,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '12.04.2025',
      },
      {
        id: 3,
        imgSrc: subMenuProjects,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '10.04.2025',
      },
      {
          id: 4,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 5,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 6,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
        {
          id: 7,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 8,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 9,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
    ];

const NewsItems = () => {


      const { t } = useTranslation();

  return (
  <div className='pt-[88px] pd:mt-[104px] bg-[#FBFBFB] h-[2400px] md:h-[2000px]'>
          <div className='max-w-containerSm md:max-w-container mx-auto'>

  {/* desktop versiya */}

          <div className='relative md:flex items-center hidden '>
    {/* Sağ div */}
    <div className='w-[52%] ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers1} />
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='absolute left-0 z-10 w-[52%]  bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>İnsan Resursları</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Biz komanda üzvlərimizə böyük dəyər veririk, onların inkişafına dəstək oluruq. İşə qəbul prosesində şəffaflıq və ədalətli yanaşma tətbiq edərək namizədləri obyektiv kriteriyalar əsasında qiymətləndiririk. Komanda üzvlərimizə bacarıqların artırılması və peşəkar yolda irəliləməsi üçün mühit yaradırıq. 
      </p>
      <a className='group' href='/careers-resource'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                          <img 
                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                src={rightArrow}
                                                                alt=""
                                                              />
                                                              <img
                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                src={rightArrowHover}
                                                                alt=""
                                                              />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:flex items-center mt-[100px]  hidden '>
    {/* Sağ div */}
    <div className='absolute right-0 z-10 w-[52%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Şirkətimizdə həyat</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Komanda ruhunun gücləndirilməsi bizim üçün önəmlidir. Biz komanda qurma fəaliyyətləri və müxtəlif tədbirlər vasitəsilə səmimi, mehriban, peşəkar mühit yaradırıq.
      </p>
      <a className='group' href='/careers-life'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                          <img 
                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                src={rightArrow}
                                                                alt=""
                                                              />
                                                              <img
                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                src={rightArrowHover}
                                                                alt=""
                                                              />
        </div>
      </a>
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='w-[52%] mr-auto z-0'>
      <img className='w-full h-full object-cover' src={careers2} />
    </div>
  </div>
  <div className='relative md:flex items-center mt-[100px] hidden '>
    {/* Sağ div */}
    <div className='w-[52%] ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers3} />
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='absolute left-0 z-10 w-[52%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Tələbələr və Başlanğıc Səviyyə Mütəxəssisləri</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Təcrübə proqramı vasitəsilə nəzəri biliklər və əyani təcrübə əsasında tələbələr və  məzunlar üçün xüsusi imkanlar təklif edirik. Biz onların inkişafını məşğulluq seminarları, karyera sərgiləri və mentorluq proqramları ilə dəstəkləyirik.

      </p>
      <a className='group' href='/careers-starters'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                          <img 
                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                src={rightArrow}
                                                                alt=""
                                                              />
                                                              <img
                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                src={rightArrowHover}
                                                                alt=""
                                                              />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:flex items-center mt-[100px]  hidden '>
    {/* Sağ div */}
    <div className='absolute right-0 z-10 w-[52%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Təcrübəli Mütəxəssislər</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Şirkətimizdə təcrübəli mütəxəssislər mürəkkəb layihələrin öhdəsindən gələrək bacarıqlarını daim inkişaf etdirir. Akondda onların fəaliyyətini, töhfələrini, yeni ideyalarını dəstəkləyir. 
      </p>
      <a className='group' href='/careers-professionals'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                          <img 
                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                src={rightArrow}
                                                                alt=""
                                                              />
                                                              <img
                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                src={rightArrowHover}
                                                                alt=""
                                                              />
        </div>
      </a>
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='w-[52%] mr-auto z-0'>
      <img className='w-full h-full object-cover' src={careers4} />
    </div>
  </div>
  <div className='relative md:flex items-center mt-[100px]  hidden'>
    {/* Sağ div */}
    <div className='w-[52%] ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers5} />
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='absolute left-0 z-10 w-[52%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Vakansiyalarımız</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Kayera yolunuza bizimlə davam edin. Böyük layihələrin ayrılmaz hissəsi olaraq  dəyərli təcrübə qazanmaq imkanını əldə edin

      </p>
      <a className='group' href='/careers-jobs'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                          <img 
                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                src={rightArrow}
                                                                alt=""
                                                              />
                                                              <img
                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                src={rightArrowHover}
                                                                alt=""
                                                              />
        </div>
      </a>
    </div>
  </div>















   {/* mobil versiya */}

  <div className='relative md:hidden items-center'>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers1} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>İnsan Resursları</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Biz komanda üzvlərimizə böyük dəyər veririk, onların inkişafına dəstək oluruq. İşə qəbul prosesində şəffaflıq və ədalətli yanaşma tətbiq edərək namizədləri obyektiv kriteriyalar əsasında qiymətləndiririk. Komanda üzvlərimizə bacarıqların artırılması və peşəkar yolda irəliləməsi üçün mühit yaradırıq. 
      </p>
      <a href='/careers-resource'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:hidden items-center mt-[360px] '>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers2} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Şirkətimizdə həyat</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Komanda ruhunun gücləndirilməsi bizim üçün önəmlidir. Biz komanda qurma fəaliyyətləri və müxtəlif tədbirlər vasitəsilə səmimi, mehriban, peşəkar mühit yaradırıq.
      </p>
      <a href='/careers-life'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:hidden items-center mt-[270px] '>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers3} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Tələbələr və Başlanğıc Səviyyə Mütəxəssisləri</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Təcrübə proqramı vasitəsilə nəzəri biliklər və əyani təcrübə əsasında tələbələr və  məzunlar üçün xüsusi imkanlar təklif edirik. Biz onların inkişafını məşğulluq seminarları, karyera sərgiləri və mentorluq proqramları ilə dəstəkləyirik.

      </p>
      <a href='/careers-starters'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:hidden items-center mt-[340px] '>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers4} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Təcrübəli Mütəxəssislər</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Şirkətimizdə təcrübəli mütəxəssislər mürəkkəb layihələrin öhdəsindən gələrək bacarıqlarını daim inkişaf etdirir. Akond onların fəaliyyətini, töhfələrini, yeni ideyalarını dəstəkləyir. 
      </p>
      <a href='/careers-professionals'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:hidden items-center mt-[270px] '>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={careers5} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Vakansiyalarımız</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Kayera yolunuza bizimlə davam edin. Böyük layihələrin ayrılmaz hissəsi olaraq  dəyərli təcrübə qazanmaq imkanını əldə edin
      </p>
      <a href='/careers-jobs'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  
  
      </div>
      </div>
  )
}

export default NewsItems